import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { Icon, SecondaryTextXlBold, SecondaryTextSmBold } from 'atoms';
import { Mt1, Mt8 } from 'wrappers';
import { ThinkingEmojiSvg } from 'components/icons';
import getIsMobile from "components/atoms/utils/getIsMobile";
import { GenericWrapper, TextCenterWrapper } from 'wrappers';

const isMobile = getIsMobile();

const template = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Icon,
      name: 'Icon',
      displayValue: ({ }) => ThinkingEmojiSvg({}),
    },
    {
      wrapper: GenericWrapper,
      name: "Wrapper",
      atoms: [
        {
          component: isMobile ? wrap(wrap(SecondaryTextSmBold, TextCenterWrapper), Mt8) : wrap(wrap(SecondaryTextXlBold, TextCenterWrapper), Mt8),
          name: 'PrimayText',
          displayValue: ({ primayText }) => primayText ?? `No results to see .`,
        },
        {
          component: isMobile ? wrap(wrap(SecondaryTextSmBold, TextCenterWrapper), Mt1) : wrap(wrap(SecondaryTextXlBold, TextCenterWrapper), Mt1),
          name: 'SecondaryText',
          displayValue: ({ secondaryText }) => secondaryText ?? "",
        },
      ]
    },
    
  ],
})
